import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { fetchCandidateDetails } from "./ShowCandidateDetailsAPI"

const initialState = {
    data: null,
    loading: false,
    error: null,
    successMessage: null,
}

export const fetchCandidateDetailsAsync = createAsyncThunk(
    "ShowCandidate/fetch",
    async (candidateId, { rejectWithValue }) => {
        try {
            // console.log("Thunk: Fetching candidate details for UUID:", candidateId)
            const data = await fetchCandidateDetails(candidateId)
            // console.log("Thunk: Candidate details API response received")
            return data.response
        } catch (error) {
            console.error("Thunk: Error in ShowDetails:", error)
            return rejectWithValue(error.message || "Failed to fetch candidate details")
        }
    },
)

const showCandidateDetailsSlice = createSlice({
    name: "ShowCandidate",
    initialState,
    reducers: {
        clearCandidateData: (state) => {
            state.data = null
            state.error = null
            state.successMessage = null
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCandidateDetailsAsync.pending, (state) => {
                state.loading = true
                state.error = null
                state.successMessage = null
            })
            .addCase(fetchCandidateDetailsAsync.fulfilled, (state, action) => {
                state.loading = false
                state.data = action.payload
                state.successMessage = "Candidate details fetched successfully"
                state.error = null
            })
            .addCase(fetchCandidateDetailsAsync.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload || "Failed to fetch candidate details"
                state.successMessage = null
            })
    },
})

export const { clearCandidateData } = showCandidateDetailsSlice.actions
export const selectCandidateDetails = (state) => state.ShowCandidate
export default showCandidateDetailsSlice.reducer
